import React from 'react';
import { message } from 'antd';
import './style.scss';

import {
  ToastGradientSuccess,
  ToastGradientWarning,
  ToastGradientError,
  ToastGradientInfo,
  ToastErrorIcon,
  ToastSuccessIcon,
  ToastWarningIcon,
  ToastInfoIcon,
} from './icons';

type MessageType = 'success' | 'error' | 'warning' | 'info' | 'normal';

const icons: Record<MessageType, React.ReactNode> = {
  success: <ToastSuccessIcon />,
  error: <ToastErrorIcon />,
  warning: <ToastWarningIcon />,
  info: <ToastInfoIcon />,
  normal: null,
};

const gradients: Record<MessageType, React.ReactNode> = {
  success: <ToastGradientSuccess />,
  error: <ToastGradientError />,
  warning: <ToastGradientWarning />,
  info: <ToastGradientInfo />,
  normal: null,
};

function ToastComponent({ content, type }: { content: string; type: MessageType }) {
  const icon = icons[type];
  const gradient = gradients[type];
  return (
    <div className='toastContainer relative z-[3000]'>
      {gradient && <div className='absolute left-0 top-0 h-full w-[87px]'>{gradient}</div>}
      <div className={`relative flex items-center p-4`}>
        {icon && <span className='h-[24px] w-[24px]'>{icon}</span>}
        <span className='mx-4  max-w-[414px] break-words text-left'>{content}</span>
      </div>
    </div>
  );
}

function show(content: string | undefined, type: MessageType = 'normal') {
  if (!content || !content.trim()) return;

  message.config({
    maxCount: 1,
  });

  message.open({
    content: <ToastComponent content={content} type={type} />,
  });
}

function info(content: string | undefined) {
  show(content, 'info');
}

function error(content: string | undefined) {
  show(content, 'error');
}

function warning(content: string | undefined) {
  show(content, 'warning');
}

function success(content: string | undefined) {
  show(content, 'success');
}

function clear() {
  message.destroy();
}

const Toast = {
  show,
  info,
  error,
  warning,
  success,
  clear,
};

export { Toast };
